import customFetch from 'api/axios';
import { API_URL } from 'constants/config';
import reduxApi from 'redux-api';
import moment from 'moment';

const convertParams = (_paramsDate, key) => {
  return {
    ...(_paramsDate ? { [key]: moment(_paramsDate).format('YYYY-MM-DD') } : {}),
  };
};

export default reduxApi({
  getTongHopKetQuaThanhTraHanhChinh: {
    url: `${API_URL}/thong-ke-bao-cao/01-TT`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: {
          ..._params,
          ...convertParams(_params.startDate, 'startDate'),
          ...convertParams(_params.endDate, 'endDate'),
        },
      };
    },
  },
  getKetQuaThucHienKetLuanThanhTraHanhChinh: {
    url: `${API_URL}/thong-ke-bao-cao/02-TT`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: {
          ..._params,
          ...convertParams(_params.startDate, 'startDate'),
          ...convertParams(_params.endDate, 'endDate'),
        },
      };
    },
  },
  getThongKeThanhTraXayDungCoBan: {
    url: `${API_URL}/thong-ke-bao-cao/03-TT`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: {
          ..._params,
          ...convertParams(_params.startDate, 'startDate'),
          ...convertParams(_params.endDate, 'endDate'),
        },
      };
    },
  },
  getThongKeThanhTraTaiChinhNganSach: {
    url: `${API_URL}/thong-ke-bao-cao/04-TT`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: {
          ..._params,
          ...convertParams(_params.startDate, 'startDate'),
          ...convertParams(_params.endDate, 'endDate'),
        },
      };
    },
  },
  getThongKeThanhTraDatDai: {
    url: `${API_URL}/thong-ke-bao-cao/05-TT`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: {
          ..._params,
          ...convertParams(_params.startDate, 'startDate'),
          ...convertParams(_params.endDate, 'endDate'),
        },
      };
    },
  },
  getKiemTraChuyenNganh: {
    url: `${API_URL}/thong-ke-bao-cao/06-TT`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: {
          ..._params,
          ...convertParams(_params.startDate, 'startDate'),
          ...convertParams(_params.endDate, 'endDate'),
        },
      };
    },
  },
  getXuPhatKiemTraChuyenNganh: {
    url: `${API_URL}/thong-ke-bao-cao/07-TT`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: {
          ..._params,
          ...convertParams(_params.startDate, 'startDate'),
          ...convertParams(_params.endDate, 'endDate'),
        },
      };
    },
  },
  getKiemTraChiTietDoanhNghiep: {
    url: `${API_URL}/thong-ke-bao-cao/01-KQTKT`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: {
          ..._params,
          ...convertParams(_params.startDate, 'startDate'),
          ...convertParams(_params.endDate, 'endDate'),
        },
      };
    },
  },
  getKiemTraTheoKeHoachDoanhNghiep: {
    url: `${API_URL}/thong-ke-bao-cao/02-KQTKT`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: {
          ..._params,
          ...convertParams(_params.startDate, 'startDate'),
          ...convertParams(_params.endDate, 'endDate'),
        },
      };
    },
  },
  getKiemTraDotXuat: {
    url: `${API_URL}/thong-ke-bao-cao/03-KQTKT`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: {
          ..._params,
          ...convertParams(_params.startDate, 'startDate'),
          ...convertParams(_params.endDate, 'endDate'),
        },
      };
    },
  },
  getTongHopKetQuaThanhTra: {
    url: `${API_URL}/thong-ke-bao-cao/04-KQTKT`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: {
          ..._params,
          ...convertParams(_params.startDate, 'startDate'),
          ...convertParams(_params.endDate, 'endDate'),
        },
      };
    },
  },
  getThongKe: {
    url: `${API_URL}/thong-ke-bao-cao/KHTH`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params,
      };
    },
  },
}).use('fetch', customFetch);



// WEBPACK FOOTER //
// ./src/api/baoCaoThanhTra.js